import {
  Card,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { VIEWINGS_DISPATCH_GUARD } from "@/config/appConfig";

export default function HardNotFoundPage() {
  return (
    <main className="min-h-screen bg-background p-6 md:p-10">
      <div className="mx-auto flex min-h-[80vh] w-full max-w-md items-center justify-center">
        <Card className="w-full">
          <CardHeader>
            <CardTitle>404</CardTitle>
            <CardDescription>
              Inspector portal is unavailable in this environment (
              <code>{VIEWINGS_DISPATCH_GUARD.serverEnv}</code>).
            </CardDescription>
          </CardHeader>
        </Card>
      </div>
    </main>
  );
}
